export enum Country {
  HR = 'HR',
  BA = 'BA',
}
